const url = '/webApi/themes';
const stam = '';

export { url, stam };
